import {Grid, Typography} from '@mui/material';
import React, {useContext, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {formatDateByLocale} from 'commons/formatDate';
import {authContext} from 'contextApi/context/auth';
import RoleGuard from 'commons/guards/roleGuard';
import BlankCardWithTabs from 'components/BlankCardWithTabs/BlankCardWithTabs';
import BlankCard from 'components/BlankCard/BlankCard';
import Button from 'components/button/Button';
import BreakTimeCard from 'viewComponents/BreakTimeCard/BreakTimeCard';
import UsersOnLeaveList from 'viewComponents/UsersOnLeaveList/UsersOnLeaveList';
import HolidaysCard from 'viewComponents/HolidaysCard/HolidaysCard';
import PendingApprovalsList from 'viewComponents/PendingApprovalsList/PendingApprovalsList';
import './Dashboard.scss';
import PalowansWithDaysToExpireCard from 'viewComponents/PalowansWithDaysToExpireCard/PalowansWithDaysToExpireCard';

const Dashboard: React.FC = () => {
  const {t, i18n} = useTranslation();
  const {userDetails, state} = useContext(authContext);
  const [name, setName] = useState('');
  const currentDay = formatDateByLocale(
    new Date(),
    i18n.language as 'en' | 'es' | 'fr' | 'pt',
    'eeee, d MMMM yyyy'
  );

  useEffect(() => {
    if (userDetails?.data?.firstName) {
      setName(
        `${userDetails?.data?.firstName || ''} ${
          userDetails?.data?.lastName || ''
        }`
      );
    }
  }, [userDetails, state]);

  return (
    <div className="Dashboard w-full flex flex-col flex-wrap pt-4 lg:pt-12">
      <Typography variant="body1">{currentDay}</Typography>
      <Typography variant="h3">
        {t('dashboard.greeting', {name: name.split(' ')[0]})}
      </Typography>
      <Grid
        justifyContent="flex-end"
        direction="row"
        container
        sx={{marginBottom: 2}}
      >
        <Grid item>
          <Link to="/private/palowan/leaves/my-leaves" className="text-white">
            <Button text={t('dashboard.requestDays')} />
          </Link>
        </Grid>
      </Grid>
      <Grid container spacing={{xs: 2, lg: 4}}>
        <Grid item xs={12} lg={7}>
          <Grid container spacing={{xs: 2, lg: 4}}>
            <Grid item xs={12}>
              <BreakTimeCard userId={userDetails?.data?.id || ''} />
            </Grid>
            <Grid item xs={12}>
              <HolidaysCard />
            </Grid>
            <RoleGuard renderForAdmin>
              <Grid item xs={12}>
                <PalowansWithDaysToExpireCard />
              </Grid>
            </RoleGuard>
          </Grid>
        </Grid>
        <Grid item xs={12} lg={5}>
          <RoleGuard renderForSupervisor>
            <BlankCardWithTabs
              className="h-full"
              title={t('dashboard.managementTitle')}
              tabs={[
                {
                  label: t('dashboard.requestsToApprove'),
                  view: (
                    <PendingApprovalsList
                      userId={userDetails?.data?.id || ''}
                    />
                  ),
                },
                {
                  label: t('dashboard.palowansOnLeave'),
                  view: <UsersOnLeaveList />,
                },
              ]}
            />
          </RoleGuard>
          <RoleGuard hideForSupervisor renderForPalowan renderForAdmin>
            <BlankCard title={t('dashboard.palowansOnLeave')}>
              <UsersOnLeaveList />
            </BlankCard>
          </RoleGuard>
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
